import React from 'react'
import Header from "../../components/header/index";
import TermConditionContent from './termsconditioncontent/termConditionContent';
import Footer from "../../components/footer";


const termsandconditions = () => {
  return (
    <div className="main">
             <Header />
           
             <TermConditionContent />
             <Footer />
    </div>
  )
}

export default termsandconditions